import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DeleteDeposit, DoDeposit, GetDepositList, GetEventList } from '../../common/actions/moreAction';
import { convertDepositString, convertStyle, dateFormation, isEmpty, isMobilePage, moneyValues, no_comma } from '../../common/cores';
// import {SlideDown} from '../../utils';
import Pagenation from '../common/Pagenation';
import NavLink from 'react-router-dom/NavLink';
import DepositDetailsContentElse from './DepositDetailsContentElse';
import WithdrawalDetailsContentElse from './WithdrawalDetailsContentElse';
const MoneyDetailsContent = (props) => {

    const [money, setMoney] = useState(0);
    const [showHis, setShowHis] = useState(false);

    const lists = props.deposit.data;
    const { page, user } = props;
    let ids = [];
    const [type, setType] = useState(1);
    const onResetType = (val) => {
        setType(val)
      };
     
    // const getLists = (page) => {
    //     console.log(type)
    //     props.GetDepositList( type == 1 ? "deposit" : "withdraw", page);
    // }

    const onChange = (e) => {
        const { value, checked } = e.target; // 우선 e.target 에서 name 과 value 를 추출
        // console.log(value, checked)
        if (checked) ids.push(value);
        else ids = ids.filter(item => item !== value)
        // console.log(ids);
        // console.log(isNaN(Number(value)))
        if(!isNaN(Number(no_comma(value))))
            setMoney(Number(no_comma(value)));
        else setMoney(0);
    };

    useEffect(() => {
        // onResetType(1);
        // getLists(1);
        // SlideDown();
    }, [props.page.perPage, type])

    const reset = () => {
        setMoney(0);
    }

    const historyDelete = (value) => {
        console.log(value);
        props.DeleteDeposit({
            ids,
            all: value,
            type: 'deposit'
        })
    }
    const moneyValues = [
        {
            value: 10000,
        },
        {
            value: 30000,
        },
        {
            value: 50000,
        },
        {
            value: 100000,
        },
        {
            value: 500000,
        },
        {
            value: 1000000,
        },
        {
            value: 5000000,
        },
        {
            value: 10000000,
        },
    ]
    
    const showHisotry = () => {
        setShowHis(!showHis);
    }
    const getMoneyFormat = (val) => {
        let res = "";
        if (val / 10000 > 0) 
            res += (val / 10000) + "만원"
        val = val % 10000;
        if (val / 1000 > 0) 
            res += (val / 1000) + "천원"
        val = val % 1000;
        if (val / 100 > 0) 
            res += (val / 100) + "백원"
        val = val % 100;
        if (val / 10 > 0) 
            res += (val / 10) + "십원"
        val = val % 10;
        if (val !=0) 
            res += val
        return res
    }
    return (
        <Fragment>
            <div className="con_box30">
                 <div className="my_tab">
                    <ul>
                        <li className={type === 1 && "activee"} onClick={() => onResetType(1)}>{isEmpty(window.lang["입금내역"]) ? "입금내역" : window.lang["입금내역"]}</li>
                        <li className={type === 2 && "activee"} onClick={() => onResetType(2)}>{isEmpty(window.lang["출금내역"]) ? "출금내역" : window.lang["출금내역"]}</li>
                    </ul>
                </div>
            </div>
                {
                    type === 1 && 
                    <DepositDetailsContentElse></DepositDetailsContentElse>
                }
                {
                    type === 2 && 
                    <WithdrawalDetailsContentElse></WithdrawalDetailsContentElse>
                }
        </Fragment>

    );
};

const mapStateToProps = state => ({
    user: state.user,
    deposit: state.more.deposit,
    page: state.page
})

export default connect(mapStateToProps, { GetDepositList, DoDeposit, DeleteDeposit })(MoneyDetailsContent);


// WEBPACK FOOTER //
// ./src/components/account/MoneyDetailsContent.js